<template>
  <div
    class="steps-register d-none d-lg-block"
    :style="{ '--rows': names.length + 1 }"
  >
    <div
      v-for="(name, i) in names"
      :key="i"
      class="step"
      :class="{ past: step > i + 1, current: step === i + 1 }"
      @click="$emit('change-step', i + 1)"
    >
      <div class="circle pr-6" :style="style(i)" role="button"></div>
      <div role="button" class="description">{{ name }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Number,
      default: 1
    },
    names: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    style(i) {
      return '--step: "' + (i + 1) + '"';
    }
  }
};
</script>
<style lang="scss" scoped>
.steps-register {
  padding: 16px;
  .step {
    display: flex;
    color: #8d8799;
    transition: 0.3s all;

    &:hover {
      color: #5a5466;
      .circle {
        &::after {
          box-shadow: 0px 4.99685px 6px rgba(0, 0, 0, 0.1),
            0px 8px 16px 8px rgba(0, 0, 0, 0.05);
        }
      }
    }
    &:active {
      color: #5a5466;
      .circle {
        &::after {
          box-shadow: 0px 16px 32px 12px rgba(0, 0, 0, 0.08),
            0px 4.99685px 14.9905px rgba(0, 0, 0, 0.15);
          outline: 1px solid #c09df5;
        }
      }
    }
    &:last-child {
      .circle {
        border-left: none;
        margin-left: 2px;
        padding-bottom: 0;
      }
    }
    .circle {
      position: relative;
      width: 32px;
      padding-bottom: 64px;
      border-left: 2px solid #e0e1e6;

      &::after {
        content: var(--step);

        top: 0;
        position: absolute;
        transition: 0.4s all;
        transform: translateX(calc(-50% - 1px));
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 24px;
        max-width: 24px;
        aspect-ratio: 1;
        font-size: 12px;
        color: #6d8af3;
        border-radius: 50%;
        background-color: white;
        border: 1px solid #b2c1f5;
        outline: 1px solid transparent;
      }
    }
    &.current {
      color: #2d50cd;
      .circle {
        &::after {
          top: -4px;
          font-size: 16px;
          min-width: 32px;
          max-width: 32px;
          border: 1px solid #5576ec;
        }
      }
      &:hover,
      &:active {
        color: #4c1a97;
      }
      &:active {
        .circle {
          &::after {
            outline: 1px solid #5576ec;
          }
        }
      }
    }
    &.past {
      color: #6d8af3;
      .circle {
        border-left: 2px solid #5576ec;
        &::after {
          color: white;
          background: #5576ec;
          border: 1px solid #2d50cd;
        }
      }
      &:hover,
      &:active {
        color: #5576ec;
      }
      &:active {
        .circle {
          &::after {
            outline: 1px solid #2d50cd;
          }
        }
      }
    }
  }
}
</style>
